var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m20.216 3-7.096 7.521m0 0L7.349 3H3l7.776 10.134m2.344-2.613L21 20.791h-4.349l-5.875-7.657m0 0L3.42 21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLine);
export default __webpack_public_path__ + "static/media/twitter_line.cccdf48e7cadc5d51e985ceb0bed7d3f.svg";
export { ForwardRef as ReactComponent };